var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDawn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1375_281469",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13L20.5 14.5L16 19L11.5 14.5L13 13L16 16L19 13Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.5L22.6213 16.6213L24.7426 14.5L22.6213 12.3787L20.5 14.5ZM19 13L21.1213 10.8787L19 8.75736L16.8787 10.8787L19 13ZM16 16L13.8787 18.1213L16 20.2426L18.1213 18.1213L16 16ZM13 13L15.1213 10.8787L13 8.75736L10.8787 10.8787L13 13ZM11.5 14.5L9.37868 12.3787L7.25736 14.5L9.37868 16.6213L11.5 14.5ZM16 19L13.8787 21.1213L16 23.2426L18.1213 21.1213L16 19ZM22.6213 12.3787L21.1213 10.8787L16.8787 15.1213L18.3787 16.6213L22.6213 12.3787ZM16.8787 10.8787L13.8787 13.8787L18.1213 18.1213L21.1213 15.1213L16.8787 10.8787ZM18.1213 13.8787L15.1213 10.8787L10.8787 15.1213L13.8787 18.1213L18.1213 13.8787ZM10.8787 10.8787L9.37868 12.3787L13.6213 16.6213L15.1213 15.1213L10.8787 10.8787ZM9.37868 16.6213L13.8787 21.1213L18.1213 16.8787L13.6213 12.3787L9.37868 16.6213ZM18.1213 21.1213L22.6213 16.6213L18.3787 12.3787L13.8787 16.8787L18.1213 21.1213Z",
    fill: "inherit",
    mask: "url(#path-2-inside-1_1375_281469)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDawn);
export default __webpack_public_path__ + "static/media/sort-dawn.9fba4db5b01024731a6fb89668e4b3c2.svg";
export { ForwardRef as ReactComponent };